import React, { Component, createContext } from "react";
import { ApiUrl } from "./apiUrl";
import jsCookie from "js-cookie";
const { Provider, Consumer } = createContext();

//get theme settings

// Then create a provider Component
class AppProvider extends Component {
  state = {
    userLoggedIn: false,
    profile: {
      userName: "",
      id: null,
      token: jsCookie.get("token")
    },
    errMsg: "",
    userInputName: "User Name",
    userInputPass: "Password",
    toggleLogin: () => {
      const setTo = !this.state.userLoggedIn;
      this.setState({ userLoggedIn: setTo });
    }
  };
  componentDidMount() {
    if (jsCookie.get("token") && jsCookie.get("userName")) {
      this.setState({ userLoggedIn: true });
    }
  }
  render() {
    return (
      <Provider
        value={{
          userName: this.state.profile.userName,
          userLoggedIn: this.state.userLoggedIn,
          formOpen: this.state.formOpen,
          userInputName: this.state.userInputName,
          errMsg: this.state.errMsg,
          userInputPass: this.state.userInputPass,

          handleLogout: () => {
            jsCookie.remove("token");
            jsCookie.remove("userName");
            jsCookie.remove("id");
            this.setState({
              profile: {
                userName: "",
                id: "",
                token: ""
              },
              userLoggedIn: false
            });
          },
          handleContact: async (e, name, phone, email, mess) => {
            e.preventDefault();
            if (name === "" || phone === "" || email === "" || mess === "") {
              this.setState({
                errMsg: "Συμπληρώστε όλα τα πεδία"
              });
            } else {
              const data = {
                name,
                phone,
                email,
                mess
              };

              await fetch(`${ApiUrl.apiUrl}/wp-json/orpheus/v1/contact`, {
                method: "POST",
                xhrFields: { withCredentials: true },
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
              })
                .then(response => {
                  return response.json();
                })
                .then(myJson => {
                  if (!myJson.success) {
                    this.setState({
                      errMsg: "Ουπς ... κάτι δεν πήγε καλά!"
                    });
                  } else {
                    this.setState({
                      errMsg: myJson.success
                    });
                  }
                });
            }
          },
          handleLogin: async (e, usr, pass, his) => {
            e.preventDefault();
            if (usr === "" || pass === "") {
              this.setState({
                errMsg: "Συμπληρώστε όλα τα πεδία"
              });
            } else {
              const data = {
                username: usr,
                password: pass
              };
              await fetch(`${ApiUrl.apiUrl}/wp-json/jwt-auth/v1/token`, {
                method: "POST",
                xhrFields: { withCredentials: true },
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
              })
                .then(response => {
                  return response.json();
                })
                .then(myJson => {
                  if (myJson.code === "[jwt_auth] invalid_username") {
                    this.setState({
                      errMsg: "Το Όνομα Χρήστη δεν είναι έγκυρο!"
                    });
                  } else if (myJson.code === "[jwt_auth] incorrect_password") {
                    this.setState({
                      errMsg: "Ο κωδικός δεν είναι σωστός!"
                    });
                  } else if (myJson.code === "[jwt_auth] invalid_email") {
                    this.setState({
                      errMsg: "Το email δεν είναι έγκυρο!"
                    });
                  } else {
                    this.setState({
                      profile: {
                        userName: myJson.user_nicename.replace(/\b\w/g, l =>
                          l.toUpperCase()
                        ),
                        token: myJson.token
                      },
                      userLoggedIn: true
                    });
                    jsCookie.set("token", myJson.token, { expires: 30 });
                    jsCookie.set("userName", myJson.username);
                    his.push(`${process.env.PUBLIC_URL}/account`);
                  }
                });
            }
          },
          handleRegister: (
            e,
            username,
            phone,
            email,
            password,
            confirm,
            his,
            tos
          ) => {
            e.preventDefault();
            if (
              username === "" ||
              phone === "" ||
              email === "" ||
              password === "" ||
              tos === false
            ) {
              console.log("Παρακαλώ συμπληρώστε όλα τα πεδία!");
            } else if (password !== confirm) {
              console.log("Οι κωδικοί πρόσβασης δεν αντιστοιχούνται!");
            } else {
              const data = {
                username,
                phone,
                email,
                password,
                role: "exhibitor"
              };
              fetch(`${ApiUrl.apiUrl}/wp-json/orpheus/v1/users/register`, {
                method: "POST",
                xhrFields: { withCredentials: true },
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
              })
                .then(response => {
                  return response.json();
                })
                .then(myJson => {
                  if (myJson.code > 200) {
                    this.setState({
                      errMsg: myJson.message
                    });
                  } else {
                    //@TODO add path for prod /app/
                    his.push(`${process.env.PUBLIC_URL}/sign-in`);
                  }
                });
            }
          }
        }}
      >
        {this.props.children}
      </Provider>
    );
  }
}
export { AppProvider };

export default Consumer;



// WEBPACK FOOTER //
// ./src/AppProvider.js